import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL || '';

/**
 * Template variations registry
 * Contains information about different variations of document templates
 */
const TEMPLATE_VARIATIONS = {
  g702: [
    {
      id: 'g702_standard',
      name: 'G702 - Standard AIA Format',
      description: 'Standard AIA G702 Application and Certificate for Payment',
      version: 'Standard',
      fieldMappings: {
        project_name: { x: 0.15, y: 0.12, width: 0.4, height: 0.03 },
        application_number: { x: 0.85, y: 0.12, width: 0.1, height: 0.03 },
        period_to: { x: 0.65, y: 0.16, width: 0.15, height: 0.03 },
        contract_date: { x: 0.65, y: 0.20, width: 0.15, height: 0.03 },
        architect: { x: 0.15, y: 0.20, width: 0.4, height: 0.03 },
        contractor: { x: 0.15, y: 0.16, width: 0.4, height: 0.03 },
        contract_sum: { x: 0.75, y: 0.40, width: 0.2, height: 0.03 },
        change_orders: { x: 0.75, y: 0.44, width: 0.2, height: 0.03 },
        contract_sum_to_date: { x: 0.75, y: 0.48, width: 0.2, height: 0.03 },
        total_completed_stored: { x: 0.75, y: 0.52, width: 0.2, height: 0.03 },
        retainage: { x: 0.75, y: 0.56, width: 0.2, height: 0.03 },
        total_earned_less_retainage: { x: 0.75, y: 0.60, width: 0.2, height: 0.03 },
        previous_certificates: { x: 0.75, y: 0.64, width: 0.2, height: 0.03 },
        current_payment: { x: 0.75, y: 0.68, width: 0.2, height: 0.03 },
        balance_to_finish: { x: 0.75, y: 0.72, width: 0.2, height: 0.03 }
      },
      identifiers: [
        'AIA Document G702',
        'APPLICATION AND CERTIFICATE FOR PAYMENT',
        'APPLICATION NO:',
        'PERIOD TO:'
      ]
    },
    {
      id: 'g702_modified',
      name: 'G702 - Modified Format',
      description: 'Modified G702 with different field positions',
      version: 'Modified',
      fieldMappings: {
        project_name: { x: 0.15, y: 0.10, width: 0.4, height: 0.03 },
        application_number: { x: 0.80, y: 0.10, width: 0.1, height: 0.03 },
        period_to: { x: 0.60, y: 0.14, width: 0.15, height: 0.03 },
        contract_date: { x: 0.60, y: 0.18, width: 0.15, height: 0.03 },
        architect: { x: 0.15, y: 0.18, width: 0.4, height: 0.03 },
        contractor: { x: 0.15, y: 0.14, width: 0.4, height: 0.03 },
        contract_sum: { x: 0.70, y: 0.38, width: 0.2, height: 0.03 },
        change_orders: { x: 0.70, y: 0.42, width: 0.2, height: 0.03 },
        contract_sum_to_date: { x: 0.70, y: 0.46, width: 0.2, height: 0.03 },
        total_completed_stored: { x: 0.70, y: 0.50, width: 0.2, height: 0.03 },
        retainage: { x: 0.70, y: 0.54, width: 0.2, height: 0.03 },
        total_earned_less_retainage: { x: 0.70, y: 0.58, width: 0.2, height: 0.03 },
        previous_certificates: { x: 0.70, y: 0.62, width: 0.2, height: 0.03 },
        current_payment: { x: 0.70, y: 0.66, width: 0.2, height: 0.03 },
        balance_to_finish: { x: 0.70, y: 0.70, width: 0.2, height: 0.03 }
      },
      identifiers: [
        'APPLICATION AND CERTIFICATE FOR PAYMENT',
        'APPLICATION NUMBER:',
        'PERIOD ENDING:'
      ]
    }
  ],
  g703: [
    {
      id: 'g703_standard',
      name: 'G703 - Standard AIA Format',
      description: 'Standard AIA G703 Continuation Sheet',
      version: 'Standard',
      fieldMappings: {
        project_name: { x: 0.15, y: 0.12, width: 0.4, height: 0.03 },
        application_number: { x: 0.85, y: 0.12, width: 0.1, height: 0.03 },
        period_to: { x: 0.65, y: 0.16, width: 0.15, height: 0.03 },
        architect: { x: 0.15, y: 0.20, width: 0.4, height: 0.03 },
        contractor: { x: 0.15, y: 0.16, width: 0.4, height: 0.03 }
      },
      tableMapping: {
        startY: 0.25,
        endY: 0.85,
        columns: [
          { name: 'item_no', x: 0.05, width: 0.05 },
          { name: 'description', x: 0.10, width: 0.30 },
          { name: 'scheduled_value', x: 0.40, width: 0.10 },
          { name: 'work_completed_previous', x: 0.50, width: 0.10 },
          { name: 'work_completed_current', x: 0.60, width: 0.10 },
          { name: 'materials_stored', x: 0.70, width: 0.10 },
          { name: 'total_completed_stored', x: 0.80, width: 0.10 },
          { name: 'percentage', x: 0.90, width: 0.05 },
          { name: 'balance_to_finish', x: 0.95, width: 0.10 },
          { name: 'retainage', x: 1.05, width: 0.10 }
        ]
      },
      identifiers: [
        'AIA Document G703',
        'CONTINUATION SHEET',
        'APPLICATION NO:',
        'PERIOD TO:'
      ]
    },
    {
      id: 'g703_modified',
      name: 'G703 - Modified Format',
      description: 'Modified G703 with different field positions',
      version: 'Modified',
      fieldMappings: {
        project_name: { x: 0.15, y: 0.10, width: 0.4, height: 0.03 },
        application_number: { x: 0.80, y: 0.10, width: 0.1, height: 0.03 },
        period_to: { x: 0.60, y: 0.14, width: 0.15, height: 0.03 },
        architect: { x: 0.15, y: 0.18, width: 0.4, height: 0.03 },
        contractor: { x: 0.15, y: 0.14, width: 0.4, height: 0.03 }
      },
      tableMapping: {
        startY: 0.22,
        endY: 0.85,
        columns: [
          { name: 'item_no', x: 0.05, width: 0.05 },
          { name: 'description', x: 0.10, width: 0.30 },
          { name: 'scheduled_value', x: 0.40, width: 0.10 },
          { name: 'work_completed_previous', x: 0.50, width: 0.10 },
          { name: 'work_completed_current', x: 0.60, width: 0.10 },
          { name: 'materials_stored', x: 0.70, width: 0.10 },
          { name: 'total_completed_stored', x: 0.80, width: 0.10 },
          { name: 'percentage', x: 0.90, width: 0.05 },
          { name: 'balance_to_finish', x: 0.95, width: 0.10 },
          { name: 'retainage', x: 1.05, width: 0.10 }
        ]
      },
      identifiers: [
        'CONTINUATION SHEET',
        'APPLICATION NUMBER:',
        'PERIOD ENDING:'
      ]
    }
  ],
  budget: [
    {
      id: 'budget_standard',
      name: 'Developer Budget - Standard Format',
      description: 'Standard Developer Budget Format',
      version: 'Standard',
      fieldMappings: {
        project_name: { x: 0.15, y: 0.10, width: 0.4, height: 0.03 },
        date: { x: 0.80, y: 0.10, width: 0.15, height: 0.03 }
      },
      tableMapping: {
        startY: 0.20,
        endY: 0.90,
        columns: [
          { name: 'line_item', x: 0.05, width: 0.10 },
          { name: 'description', x: 0.15, width: 0.30 },
          { name: 'budget_amount', x: 0.45, width: 0.15 },
          { name: 'actual_cost', x: 0.60, width: 0.15 },
          { name: 'variance', x: 0.75, width: 0.15 },
          { name: 'percentage_complete', x: 0.90, width: 0.10 }
        ]
      },
      identifiers: [
        'Developer Budget',
        'Project Budget',
        'Budget Summary'
      ]
    }
  ],
  gc_budget: [
    {
      id: 'gc_budget_standard',
      name: 'General Contractor Budget - Standard Format',
      description: 'Standard General Contractor Budget Format',
      version: 'Standard',
      fieldMappings: {
        project_name: { x: 0.15, y: 0.10, width: 0.4, height: 0.03 },
        date: { x: 0.80, y: 0.10, width: 0.15, height: 0.03 }
      },
      tableMapping: {
        startY: 0.20,
        endY: 0.90,
        columns: [
          { name: 'line_item', x: 0.05, width: 0.10 },
          { name: 'description', x: 0.15, width: 0.30 },
          { name: 'budget_amount', x: 0.45, width: 0.15 },
          { name: 'actual_cost', x: 0.60, width: 0.15 },
          { name: 'variance', x: 0.75, width: 0.15 },
          { name: 'percentage_complete', x: 0.90, width: 0.10 }
        ]
      },
      identifiers: [
        'General Contractor Budget',
        'GC Budget',
        'Construction Budget'
      ]
    }
  ],
  schedule: [
    {
      id: 'schedule_standard',
      name: 'Construction Schedule - Standard Format',
      description: 'Standard Construction Schedule Format',
      version: 'Standard',
      fieldMappings: {
        project_name: { x: 0.15, y: 0.10, width: 0.4, height: 0.03 },
        date: { x: 0.80, y: 0.10, width: 0.15, height: 0.03 }
      },
      tableMapping: {
        startY: 0.20,
        endY: 0.90,
        columns: [
          { name: 'activity_id', x: 0.05, width: 0.10 },
          { name: 'description', x: 0.15, width: 0.30 },
          { name: 'duration', x: 0.45, width: 0.10 },
          { name: 'start_date', x: 0.55, width: 0.15 },
          { name: 'finish_date', x: 0.70, width: 0.15 },
          { name: 'predecessors', x: 0.85, width: 0.10 },
          { name: 'successors', x: 0.95, width: 0.10 }
        ]
      },
      identifiers: [
        'Construction Schedule',
        'Project Schedule',
        'Activity ID',
        'Duration'
      ]
    }
  ],
  invoice: [
    {
      id: 'invoice_standard',
      name: 'Soft Cost Invoice - Standard Format',
      description: 'Standard Soft Cost Invoice Format',
      version: 'Standard',
      fieldMappings: {
        invoice_number: { x: 0.80, y: 0.15, width: 0.15, height: 0.03 },
        invoice_date: { x: 0.80, y: 0.20, width: 0.15, height: 0.03 },
        vendor: { x: 0.15, y: 0.25, width: 0.40, height: 0.03 },
        description: { x: 0.15, y: 0.35, width: 0.70, height: 0.10 },
        amount: { x: 0.80, y: 0.60, width: 0.15, height: 0.03 },
        due_date: { x: 0.80, y: 0.25, width: 0.15, height: 0.03 }
      },
      identifiers: [
        'Invoice',
        'Bill To',
        'Invoice Number',
        'Invoice Date',
        'Amount Due'
      ]
    }
  ],
  requisition: [
    {
      id: 'requisition_standard',
      name: 'Borrower Requisition Letter - Standard Format',
      description: 'Standard Borrower Requisition Letter Format',
      version: 'Standard',
      fieldMappings: {
        requisition_number: { x: 0.80, y: 0.15, width: 0.15, height: 0.03 },
        date: { x: 0.80, y: 0.20, width: 0.15, height: 0.03 },
        project_name: { x: 0.15, y: 0.25, width: 0.40, height: 0.03 },
        borrower: { x: 0.15, y: 0.30, width: 0.40, height: 0.03 },
        lender: { x: 0.15, y: 0.35, width: 0.40, height: 0.03 },
        amount_requested: { x: 0.80, y: 0.40, width: 0.15, height: 0.03 }
      },
      identifiers: [
        'Requisition',
        'Requisition Letter',
        'Borrower',
        'Lender',
        'Amount Requested'
      ]
    }
  ],
  contract: [
    {
      id: 'contract_standard',
      name: 'Construction Contract - Standard Format',
      description: 'Standard Construction Contract Format',
      version: 'Standard',
      fieldMappings: {
        contract_number: { x: 0.80, y: 0.15, width: 0.15, height: 0.03 },
        date: { x: 0.80, y: 0.20, width: 0.15, height: 0.03 },
        owner: { x: 0.15, y: 0.25, width: 0.40, height: 0.03 },
        contractor: { x: 0.15, y: 0.30, width: 0.40, height: 0.03 },
        project: { x: 0.15, y: 0.35, width: 0.40, height: 0.03 },
        contract_sum: { x: 0.80, y: 0.40, width: 0.15, height: 0.03 }
      },
      identifiers: [
        'Construction Contract',
        'Agreement',
        'Contract Sum',
        'Scope of Work',
        'Terms and Conditions'
      ]
    }
  ]
};

/**
 * Service for template library operations
 */
export default {
  /**
   * Get all template variations for a document type
   * @param {string} documentType - The document type (e.g., 'g702', 'g703')
   * @returns {Array} - Array of template variations
   */
  getTemplateVariations(documentType) {
    return TEMPLATE_VARIATIONS[documentType] || [];
  },

  /**
   * Get all document types with template variations
   * @returns {Array} - Array of document types
   */
  getDocumentTypesWithTemplates() {
    return Object.keys(TEMPLATE_VARIATIONS);
  },

  /**
   * Get a specific template variation
   * @param {string} documentType - The document type (e.g., 'g702', 'g703')
   * @param {string} templateId - The template ID
   * @returns {Object} - Template variation object
   */
  getTemplateVariation(documentType, templateId) {
    const variations = TEMPLATE_VARIATIONS[documentType] || [];
    return variations.find(v => v.id === templateId) || null;
  },

  /**
   * Identify the best template match for a document
   * @param {string} documentType - The document type (e.g., 'g702', 'g703')
   * @param {Array} textBlocks - Array of text blocks from OCR with positions
   * @returns {Object} - Best matching template and confidence score
   */
  identifyTemplateVariation(documentType, textBlocks) {
    const variations = TEMPLATE_VARIATIONS[documentType] || [];
    if (variations.length === 0) {
      return { template: null, confidence: 0 };
    }

    // If only one variation exists, return it with medium confidence
    if (variations.length === 1) {
      return { template: variations[0], confidence: 70 };
    }

    // Calculate match scores for each variation
    const scores = variations.map(template => {
      let matchCount = 0;
      let totalIdentifiers = template.identifiers.length;

      // Check for identifier text matches
      template.identifiers.forEach(identifier => {
        const found = textBlocks.some(block => 
          block.text.includes(identifier)
        );
        if (found) matchCount++;
      });

      // Calculate confidence based on percentage of identifiers found
      const confidence = Math.round((matchCount / totalIdentifiers) * 100);
      return { template, confidence };
    });

    // Return the template with the highest confidence
    scores.sort((a, b) => b.confidence - a.confidence);
    return scores[0];
  },

  /**
   * Map fields to document positions based on template
   * @param {Object} template - The template variation
   * @param {number} documentWidth - The document width in pixels
   * @param {number} documentHeight - The document height in pixels
   * @returns {Object} - Mapped field positions in pixels
   */
  mapFieldPositions(template, documentWidth, documentHeight) {
    if (!template || !template.fieldMappings) {
      return {};
    }

    const mappedFields = {};
    
    // Convert relative positions to absolute pixel positions
    Object.entries(template.fieldMappings).forEach(([fieldName, position]) => {
      mappedFields[fieldName] = {
        x: Math.round(position.x * documentWidth),
        y: Math.round(position.y * documentHeight),
        width: Math.round(position.width * documentWidth),
        height: Math.round(position.height * documentHeight)
      };
    });

    return mappedFields;
  },

  /**
   * Map table columns to document positions based on template
   * @param {Object} template - The template variation
   * @param {number} documentWidth - The document width in pixels
   * @param {number} documentHeight - The document height in pixels
   * @returns {Object} - Mapped table information in pixels
   */
  mapTablePositions(template, documentWidth, documentHeight) {
    if (!template || !template.tableMapping) {
      return null;
    }

    const tableMapping = template.tableMapping;
    
    // Convert relative positions to absolute pixel positions
    const mappedTable = {
      startY: Math.round(tableMapping.startY * documentHeight),
      endY: Math.round(tableMapping.endY * documentHeight),
      columns: tableMapping.columns.map(column => ({
        name: column.name,
        x: Math.round(column.x * documentWidth),
        width: Math.round(column.width * documentWidth)
      }))
    };

    return mappedTable;
  },

  /**
   * Save a new template variation
   * @param {string} documentType - The document type (e.g., 'g702', 'g703')
   * @param {Object} template - The template variation to save
   * @returns {Promise} - Promise with save result
   */
  async saveTemplateVariation(documentType, template) {
    try {
      // In a real implementation, this would save to a database via API
      // For now, we'll just simulate a successful save
      console.log(`Saving template variation for ${documentType}:`, template);
      
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // Add to local registry (this would be handled by the backend in a real implementation)
      if (!TEMPLATE_VARIATIONS[documentType]) {
        TEMPLATE_VARIATIONS[documentType] = [];
      }
      
      const existingIndex = TEMPLATE_VARIATIONS[documentType].findIndex(t => t.id === template.id);
      if (existingIndex >= 0) {
        TEMPLATE_VARIATIONS[documentType][existingIndex] = template;
      } else {
        TEMPLATE_VARIATIONS[documentType].push(template);
      }
      
      return { success: true, message: 'Template variation saved successfully' };
    } catch (error) {
      console.error('Error saving template variation:', error);
      throw error;
    }
  },

  /**
   * Delete a template variation
   * @param {string} documentType - The document type (e.g., 'g702', 'g703')
   * @param {string} templateId - The template ID to delete
   * @returns {Promise} - Promise with delete result
   */
  async deleteTemplateVariation(documentType, templateId) {
    try {
      // In a real implementation, this would delete from a database via API
      // For now, we'll just simulate a successful delete
      console.log(`Deleting template variation ${templateId} for ${documentType}`);
      
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // Remove from local registry (this would be handled by the backend in a real implementation)
      if (TEMPLATE_VARIATIONS[documentType]) {
        const index = TEMPLATE_VARIATIONS[documentType].findIndex(t => t.id === templateId);
        if (index >= 0) {
          TEMPLATE_VARIATIONS[documentType].splice(index, 1);
        }
      }
      
      return { success: true, message: 'Template variation deleted successfully' };
    } catch (error) {
      console.error('Error deleting template variation:', error);
      throw error;
    }
  }
};